import months from './months'

export const getYear = (month) => {
  const selectedMonth = months.filter((val) => {
    return val.monthName === month
  });
  if (!selectedMonth || selectedMonth.length === 0) {
    return;
  }
  const actualmonth = new Date().getMonth() + 1;
  return (selectedMonth[0].monthNumber < actualmonth) ? new Date().getFullYear() + 1 : new Date().getFullYear();
};

// This method get the last date for current month and retrieve the last date for upcoming month for spanish and english date
// format.
export const getLastDateForUpcomingMonth = (date) => {
  const dateParts = date.split('/');
  const isSpanish = (dateParts[0] > dateParts[1]);
  const currentMonth = isSpanish ? dateParts[1] : dateParts[0];

  if (dateParts[2].length === 2) {
    const year = new Date().getFullYear().toString();
    dateParts[2] = year.substring(0, 2) + dateParts[2]
  }

  if (currentMonth === '12') {
    const newYear = Number(dateParts[2]) + 1;
    return ((isSpanish) ? '31/01/' : '01/31/') + newYear;
  }

  let newMonth = Number(currentMonth) + 1;
  const upcomingMonth = months.find(month => month.monthNumber === newMonth);
  newMonth = (newMonth < 10) ? ('0' + newMonth.toString()) : newMonth.toString();
  const upcomingDate = ((isSpanish) ?
    upcomingMonth.endDay + '/' + newMonth :
    newMonth + '/' + upcomingMonth.endDay) + '/' + (dateParts[2]);

  return upcomingDate;
}

export const getDiffDays = (date1, date2) => {
  const timeDiff = Math.abs(date2.getTime() - date1.getTime());
  const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

  return diffDays;
}

export const fillHours = (fullDay) => {
  let hours = [];
  let from = 8;
  let to = 9;

  if (fullDay) {
    from = 0;
    to = 11;
  }

  for (let i = from; i <= 11; i++) {
    hours.push({ value: i + ':00am', text: i + ':00 am' });
    hours.push({ value: i + ':30am', text: i + ':30 am' });
  }

  hours.push({ value: 12 + ':00pm', text: 12 + ':00 pm' });
  hours.push({ value: 12 + ':30pm', text: 12 + ':30 pm' });

  for (let i = 1; i <= to; i++) {
    hours.push({ value: (i + 12) + ':00pm', text: i + ':00 pm' });
    if (i !== 9) {
      hours.push({ value: (i + 12) + ':30pm', text: i + ':30 pm' });
    }
  }

  return hours;
}

export const getLastWeek = () => {
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 7);

  while (startDate.getDay() !== 1) {
    startDate.setDate(startDate.getDate() - 1);
  }

  const endDate = new Date(startDate.getTime());
  endDate.setDate(endDate.getDate() + 6);

  const lastWeek = {
    startDate,
    endDate
  };

  return lastWeek;
}

export const getLastMonth = () => {
  const startDate = new Date();
  startDate.setDate(1);
  startDate.setMonth(startDate.getMonth() - 1);

  const month = months.find(m => m.monthNumber === startDate.getMonth() + 1);
  const endDate = new Date();
  endDate.setDate(month.endDay);
  endDate.setMonth(endDate.getMonth() - 1);

  const lastMonth = {
    startDate,
    endDate
  };

  return lastMonth;
}



// WEBPACK FOOTER //
// ./src/utils/dates.js